export default __webpack_public_path__ + "static/media/8f1bc970190a9433cc6fc0c5fa0398c5.71d90178.svg";